import {
	Card,
	PaddedContainer,
	SPACING,
	genClassName,
} from "@disco/disco_core";
import React, { useState } from "react";
import useDimensions from "../../hooks/useDimensions";
import useData from "../../hooks/useData";
import LeadGenHeader from "./LeadGenHeader";
import LeadGenCarousel from "./LeadGenCarousel";
import "./lead-gen-v1.css";
import LeadGenProductRow from "./LeadGenProductRow";
import LeadGenFooter from "./LeadGenFooter";

const LeadGenV1 = ({
	totalOffers,

	activeBrandIdx,
	showNextBrand,
	showPrevBrand,

	claimOffer,
	claimedOffers,

	triggerWidgetResize,
}) => {
	const { isLargeWidget } = useDimensions();
	const { containerRef } = useData();

	const [isCarouselEngaged, setIsCarouselEngaged] = useState(false);

	const COMPUTED_PADDING = isLargeWidget ? 20 : 16; // Hard Coding values for compatibility with carousel

	return (
		<Card
			noShadow
			className={genClassName({
				base: "lead-gen",
				additional: "lead-gen-v1",
			})}
			data-testid="lead-gen-v1"
			vPadding={COMPUTED_PADDING}
			ref={containerRef}
		>
			<PaddedContainer hPadding={COMPUTED_PADDING}>
				<LeadGenHeader
					totalIdx={totalOffers}
					currIdx={activeBrandIdx}
					triggerWidgetResize={triggerWidgetResize}
					disableNavEngagement={isCarouselEngaged}
				/>
			</PaddedContainer>
			<LeadGenCarousel
				hPadding={COMPUTED_PADDING}
				marginTop={SPACING.SMALL}
				currIdx={activeBrandIdx}
				onNext={showNextBrand}
				onPrev={showPrevBrand}
				claimOffer={claimOffer}
				claimedOffers={claimedOffers}
				setIsInEngagement={setIsCarouselEngaged}
			/>
			<PaddedContainer className="lead-gen-divider" />
			<LeadGenProductRow
				vPadding={SPACING.REGULAR}
				parentHPadding={COMPUTED_PADDING}
			/>
			<LeadGenFooter hPadding={COMPUTED_PADDING} />
		</Card>
	);
};
export default LeadGenV1;
